import { type NavigationGuard } from "vue-router";
import AuthService from "@/Pages/Login/services/auth.service";
import { useNavbarStore } from "@/App/components/AppNavbar/navigation.store";
import { windowsService } from "@/App/services/windowsService";
import { RouteName } from "@/App/router/routeName";

export const checkForAuthorization: NavigationGuard = (to, _, next) => {
  if (to.meta.redirectToCasesIfAuthorized === true && AuthService.isLoggedIn()) {
    next({ name: useNavbarStore().defaultRoute });
  } else if (to.meta.requiresAuthorization !== false && !AuthService.isLoggedIn()) {
    if (!!to.query.ssoProvider || AuthService.isUserPreferToLoginViaSso()) {
      const url = AuthService.createSsoUrl({ query: { redirect: to.path, ...to.query } });
      windowsService.goTo({ url });
    } else {
      next({ name: RouteName.login, query: { redirect: to.path, ...to.query } });
    }
  } else {
    next();
  }
};
